import React from 'react';
import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import NoCover from '../../../img/no-cover.svg';
import { PromoUnitContent } from '../../../services/content_v1';

interface WelcomeEventsProps {
    title: string,
    items: PromoUnitContent[],
}

const WelcomeEvents: React.FC<WelcomeEventsProps> = ({ title, items }) => {
    const lang = useLanguage();

    return (items?.length || 0) > 0 && (
        <section className="welcome-section">
            <div className="welcome-section__back"></div>
            <div className="welcome-section__body">
                <section className="welcome-content">
                    <header className="welcome-header">
                        <h2 className="welcome-header__heading">
                            <a href={`/${lang}/public-event`}>
                                {title}
                                <LinkTo />
                            </a>
                            {/* <Link to="/public-event">
                                {title}
                                <LinkTo />
                            </Link> */}
                        </h2>
                        <div className="welcome-header__link">
                            <a href={`/${lang}/public-event`}>
                                <Trans>See all</Trans>
                                <LinkTo />
                            </a>
                            {/* <Link to="/public-event">
                                <Trans>See all</Trans>
                                <LinkTo />
                            </Link> */}
                        </div>
                    </header>

                    <div className="welcome-content__list">
                        {items.map((item, index) => (
                            <div key={index} className="welcome-content__list-item">
                                <article className="welcome-content__item">
                                    <div className="welcome-content__item-image">
                                        {item.files?.at(0) ?
                                            <img className="w-full" src={item.files?.at(0)} alt="" decoding="async" loading="lazy" style={{ objectFit: 'cover' }} />
                                            :
                                            <img src={NoCover} alt="" />
                                        }
                                    </div>
                                    <div className="welcome-content__item-name">
                                        <a href={`/${lang}/public-event/${item.id}_${translit1((item as PromoUnitContent).title) || '_'}`}>{(item as PromoUnitContent).title}</a>
                                        {/* <Link to={`/public-event/${item.id}`}>{(item as PromoUnitContent).title}</Link> */}
                                    </div>
                                </article>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </section>
    );
};

export default WelcomeEvents;